import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DetailsPageTitle from "components/common/DetailsPageTitle";
import NoDataFound from "components/common/NoDataFound";
import { DollarSign, MapPin, User, UserRound, Map, Building } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOfferDetails } from "store/actions/offerSlice";
import Spinners from "components/common/Spinners";
import Riyal from "assets/images/icons/riyal.svg";
import riyalGray2 from "assets/images/icons/riyalGray2.svg";
import { getSpaceListByType } from "store/actions/workspaceSlice";
import {
  getBranchList,
  getBranchListWithCity,
} from "store/actions/branchSlice";

const OfferDetails = () => {
  const { t } = useTranslation();
  document.title = t("Offer Details | Ashjar Space");
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { branchesList } = useSelector((state) => state.Branches);
  const { loading, offerDetails } = useSelector((state) => state.Offers);
  const { spaceLists } = useSelector((state) => state.Workspace);

  const fetchSpaceListByType = (spaceType, branches) => {
    const payload = {
      spaceTypes: [spaceType],
      branches: branches ?? [],
    };
    dispatch(getSpaceListByType(payload));
  };

  useEffect(() => {
    const fetchBranchesList = () => {
      dispatch(getBranchList());
    };

    const getDetails = () => {
      const payload = {
        id,
      };
      dispatch(getOfferDetails(payload));
      fetchBranchesList();
      dispatch(getBranchListWithCity());
    };
    getDetails();
  }, []);

  useEffect(() => {
    fetchSpaceListByType(
      offerDetails?.spaceType,
      offerDetails?.applicableBranches
    );
  }, [offerDetails]);

  const getStatusDetails = (status, expiresAt, isNeverEnd) => {
    // const isExpired = isNeverEnd
    //   ? false
    //   : expiresAt && isAfter(new Date(), parseISO(expiresAt));

    // if (isExpired) {
    //   return { label: "Expired", className: "cancelled_status" }; // Example expired style
    // }

    const statusMap = {
      1: { label: "Active", className: "completed_status" },
      0: { label: "Deactive", className: "cancelled_status" },
    };

    return statusMap[status] ?? {};
  };

  const getSpaceNames = (spaces) => {
    return (
      spaceLists
        ?.filter((space) => spaces?.includes(space._id))
        ?.map((space) => space.name)
        .join(", ") || t("No applicable Space")
    );
  };

  const getBranchNames = (applicableBranches) => {
    return (
      branchesList
        ?.filter((branch) => applicableBranches?.includes(branch._id))
        ?.map((branch) => branch.name)
        .join(", ") || t("No applicable branches")
    );
  };

  const getSpaceTypeLabel = (spaceType) => {
    const spaceTypeMap = {
      workSpace: t("Work Space"),
      meetingRoom: t("Meeting Room"),
      workShop: t("Workshop"),
    };

    return spaceTypeMap[spaceType] ?? "-";
  };

  return (
    <React.Fragment>
      <div className="page-content common_details_page workspace_details_page">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <DetailsPageTitle title={t("Offer Details")} />
            </Row>
            <div className="common_wrapper">
              <Row>
                <Col lg={12} className="mt-3">
                  <div className="title_section">
                    <h2 className="fs_24">
                      {offerDetails?.name}, {offerDetails?.nameAr || "-"}
                    </h2>
                    <h4 className="fs_16 mt-3">
                      {t("Discount Type : ")}
                      {offerDetails?.discountType || "-"}
                    </h4>
                    <h4 className="fs_16 mt-1">
                      {t("Discount Value : ")}{" "}
                      {offerDetails?.discountType !== "percentage" && (
                        <img
                          src={Riyal}
                          width={15}
                          height={15}
                          alt="riyal"
                          className="me-1"
                        />
                      )}
                      {offerDetails?.amount || "-"}
                      {offerDetails?.discountType === "percentage" && "%"}
                    </h4>

                    <p className="mt-3 fs_14 text_gray align-items-center gap-4">
                      <p>
                        <MapPin
                          className="text_gray me-1"
                          width={14}
                          height={14}
                        />
                        {getSpaceTypeLabel(offerDetails?.spaceType)}
                      </p>
                      <p>
                        <Map
                          className="text_gray me-1"
                          width={14}
                          height={14}
                        />
                        {getBranchNames(offerDetails?.applicableBranches)}
                      </p>
                      <p>
                        <Building
                          className="text_gray me-1"
                          width={14}
                          height={14}
                        />
                        {getSpaceNames(offerDetails?.spaces)}
                      </p>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
            <Row>
              <div className="g_end mt_32 mb-2">
                <button
                  className="main_btn"
                  onClick={() => {
                    navigate(
                      `/plan/offers/update-offer?id=${offerDetails?._id}`
                    );
                  }}
                >
                  {t("Edit")}
                </button>
              </div>
            </Row>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default OfferDetails;
